<template>
  <div style="background: #eeeeee">
    <AppBar>
      <template v-slot:BtnBack>
        <BtnBack />
      </template>

      <template v-slot:Notification>
        <Notification />
      </template>
    </AppBar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import AppBar from '@/components/organisms/common/navigation/AppBar'
import BtnBack from '@/components/atoms/button/BtnBack'
import Notification from '@/components/organisms/common/navigation/Notification'

export default {
  name: 'RootPage',

  components: {
    AppBar,
    BtnBack,
    Notification,
  },
}
</script>
